import React from 'react';
import Title from 'lib/src/components/typography/Title';
import ButtonRow from 'lib/src/components/button/ButtonRow';
import ContentBlock from '@components/layout/contentBlock/ContentBlock';
import ContentItem from '@components/layout/contentBlock/ContentItem';
import ContentRow from '@components/layout/contentBlock/ContentRow';
import LinkButton from '@components/button/LinkButton';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import { singleContactUsMessageBreadcrumb } from '../../../constants/breadcrumbItems';
import { ContactUsMessage as ContactUsMessageType } from 'src/types/shared/ContactUsMessages';
import dayjs from 'dayjs';

const SingleContactUsMessage: React.FC<MessageProps> = ({ message }) => {
    const { id, firstName, lastName, email, sentOn, company, message: messageText } = message;

    return (
        <>
            <Breadcrumb
                items={singleContactUsMessageBreadcrumb}
                title={`${firstName} ${lastName}`}
            />
            <Title>Details</Title>

            <ContentBlock>
                <ContentRow>
                    <ContentItem label="Name">
                        <p>{`${firstName} ${lastName}`}</p>
                    </ContentItem>
                    <ContentItem label="Email">
                        <p>
                            <a href={`mailto:${email}`}>{email}</a>
                        </p>
                    </ContentItem>
                </ContentRow>
                <ContentRow>
                    <ContentItem label="Company">
                        <p>{company}</p>
                    </ContentItem>
                    <ContentItem label="Received">
                        <p>{dayjs(sentOn).format('DD/MM/YYYY HH:mm')}</p>
                    </ContentItem>
                </ContentRow>
            </ContentBlock>

            <Title>Message</Title>
            <ContentBlock>
                <ContentRow>
                    <ContentItem label="">
                        <p>{messageText}</p>
                    </ContentItem>
                </ContentRow>
            </ContentBlock>

            <ButtonRow alignment="left">
                <LinkButton color="red" href={`/contact-us-messages/${id}/delete`}>
                    Delete
                </LinkButton>
            </ButtonRow>
        </>
    );
};

interface MessageProps {
    message: ContactUsMessageType;
}
export default SingleContactUsMessage;
